import { render } from "./PayVideoSeriesShell.vue?vue&type=template&id=4825f4c6&scoped=true"
import script from "./PayVideoSeriesShell.vue?vue&type=script&lang=js"
export * from "./PayVideoSeriesShell.vue?vue&type=script&lang=js"

import "./PayVideoSeriesShell.vue?vue&type=style&index=0&id=4825f4c6&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4825f4c6"]])

export default __exports__